import React from 'react';
import PropTypes from 'prop-types';

import {dispatch, connect} from 'utils/state_manager';

import {Typography, Box, Link, Popover} from 'views/components';
import {Translate} from 'views/module';

const ServiceDetailPopover = (props) => {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const targetRef = React.useRef();

  const setOnClick = props.setOnClick;
  const options = props.options;

  React.useEffect(() => {
    setAnchorEl(targetRef.current);
  }, [targetRef]);

  return (
    <>
      <Box
        sx={{
          textDecorationThickness: '2px solid #FFFFFF',
          float: 'right',
          pr: '8px',
        }}
        ref={targetRef}
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="7" height="9" fill="none" viewBox="0 0 7 9">
          <path fill="#fff" d="M7 4.5.25 8.397V.603L7 4.5Z"/>
        </svg>
      </Box>
      {
        anchorEl &&
        <Popover
          id="mouse-over-popover"
          sx={{
            pointerEvents: 'none',
          }}
          open={ true}
          anchorEl={anchorEl}
          anchorReference="anchorPosition"
          anchorPosition={{
            top: anchorEl.getBoundingClientRect().top - 16,
            left: anchorEl.getBoundingClientRect().right,
          }}
          PaperProps={{
            elevation: 0,
            sx: {
              borderRadius: '0px 4px 4px 0px',
            },
          }}
          onClose={() => setOnClick(false)}
          disableScrollLock
        >
          <Box
            sx={{
              backgroundColor: 'navbar.main',
              py: '8px',
              pointerEvents: 'auto',
              width: '200px',
            }}
            onClick={() => setOnClick(true)}
          >
            {
              options.map((button, index) => {
                return (
                  <Link
                    href={button.link}
                    style={{
                    }}
                    key={index}
                  >
                    <Typography
                      sx={{
                        'color': 'white',
                        'py': '8px',
                        'pl': '16px',
                        '&:hover': {
                          'textDecorationColor': '#FFFFFF',
                          'textDecorationThickness': '2px',
                          'textDecorationLine': 'underline',
                        },
                      }}
                    >
                      <Translate expression={button.title} />
                    </Typography>
                  </Link>
                );
              })
            }
          </Box>
        </Popover>
      }
    </>
  );
};
ServiceDetailPopover.propTypes = {
  setOnClick: PropTypes.func,
  options: PropTypes.array,
};

const NavbarService = (props) => {
  const [mouseOver, setMouseOver] = React.useState(false);
  const [onClick, setOnClick] = React.useState(false);

  const title = props.title;
  const link = props.link;
  const options = props.options;
  const selected = props.selected;

  const showDetails = mouseOver && !onClick;

  let sx = {};
  if (selected) {
    sx = {
      'textDecorationColor': '#FFFFFF',
      'textUnderlineOffset': '4px',
      'textDecorationThickness': '2px',
      'textDecorationLine': 'underline',
      'filter': null,
    };
  } else if (showDetails) {
    sx = {
      'textDecorationColor': '#FFFFFF',
      'textUnderlineOffset': '4px',
      'textDecorationThickness': '2px',
      'textDecorationLine': 'underline',
      'filter': null,
    };
  }

  return (
    <Box
      onMouseEnter={() => setMouseOver(true) & setOnClick(false)}
      onMouseLeave={() => setMouseOver(false)}
      onClick={() => setOnClick(true)}
      sx={{
        py: 2,
      }}
    >
      <Link
        href={link}
        sx={{
          'textDecorationLine': 'none',
          'display': 'inline-block',
          'filter': 'contrast(25%)',
          'fontWeight': selected ? 500 : 400,
          'fontSize': '16px',
          'color': 'white',
          ...sx,
        }}
      >
        <Translate expression={title} />
      </Link>
      {
        showDetails &&
          <ServiceDetailPopover
            setOnClick={setOnClick}
            options={options}
          />
      }
    </Box>
  );
};
NavbarService.propTypes = {
  title: PropTypes.string,
  link: PropTypes.string,
  options: PropTypes.array,
  selected: PropTypes.bool,
};
const mapStateToProps = (state) => ({
});

export default connect(mapStateToProps, dispatch)(React.memo(NavbarService));
